import { modeLrgb, modeRgb, useMode } from 'culori/fn';

export const rgb = useMode(modeRgb);
useMode(modeLrgb);
